import { useState } from "react";
import { HiAcademicCap } from "react-icons/hi";
import JobCard from "./Card";
import styles from "./CareersHero.module.css";

const CareersHero = ({ jobs, setSelectedJob, selectedJob }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const jobsPerPage = 9;
  const totalPages = Math.ceil(jobs.length / jobsPerPage);

  const indexOfLastJob = currentPage * jobsPerPage;
  const indexOfFirstJob = indexOfLastJob - jobsPerPage;
  const currentJobs = jobs.slice(indexOfFirstJob, indexOfLastJob);

  return (
    <div
      className={styles.container}
      style={{
        background: `url(./assets/HF.jpg)`,
        backgroundSize: "cover",
        // backgroundPosition: "10% 30%",
        backgroundAttachment: "fixed",
      }}
    >
      <div>
        <h1>{window.innerWidth < 768 ? "Careers" : "Careers At Space Labs"}</h1>
      </div>
      <p>Explore the future filled with opportunities</p>

      <h4>Current Openings</h4>

      {/* Job Cards Grid */}
      <div className={styles.jobGrid}>
        {currentJobs.map((job, index) => (
          <JobCard
            key={index}
            job={job}
            jobName={job.title}
            experience={job.experience}
            onClick={() => {
              setSelectedJob(job); // Sending job data back
              window.scrollTo({
                top: 1200,
                behavior: "smooth",
              });
            }}
            selectedJob={selectedJob} // Passing selectedJob as prop
          />
        ))}
      </div>

      {/* Pagination Controls */}
      <div className={styles.pagination}>
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
          Prev
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default CareersHero;
